module.exports = __webpack_public_path__ + "img/article-notself-bottom-doc.067ac17c.png";